import { render, staticRenderFns } from "./AirtimeDataPage.vue?vue&type=template&id=34d86a94&scoped=true"
import script from "./AirtimeDataPage.vue?vue&type=script&lang=js"
export * from "./AirtimeDataPage.vue?vue&type=script&lang=js"
import style0 from "./AirtimeDataPage.vue?vue&type=style&index=0&id=34d86a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d86a94",
  null
  
)

export default component.exports